import { useEffect, useState } from "react";
import { MaskedLines, Reveal } from "@/components/Reveal";
import { ChaliceIcon } from "@/components/Icons";
import { api } from "@/lib/api";

export default function Devotions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/devotions").then(({ data }) => setItems(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <main className="pt-16" data-testid="devotions-page">
      <section className="relative overflow-hidden noise-overlay crosshair-grid border-b border-gold/15">
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24">
          <p className="eyebrow mb-5">The Chaplain's Desk</p>
          <MaskedLines
            lines={["DEVOTIONS FOR", "THE FIRING LINE."]}
            lineClassName="font-display font-bold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight text-parchment"
          />
          <p className="mt-6 max-w-xl text-stone-300 text-sm sm:text-base leading-relaxed">
            Short reflections from our chaplains and instructors — Scripture first, drawn from
            life on the range. New devotions are posted by officers from the Command Post.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-5 sm:px-8 py-20 space-y-10">
        {loading && <div className="h-40 bg-card2/50 border border-gold/10 animate-pulse" data-testid="devotions-loading" />}
        {!loading && items.length === 0 && (
          <p className="text-stone-500 font-serif italic text-lg text-center py-16" data-testid="devotions-empty">No devotions posted yet. Check back after the next muster.</p>
        )}
        {items.map((d, i) => (
          <Reveal key={d.id} delay={0.05}>
              <article className="border border-gold/20 bg-card2/50 noise-overlay p-8 sm:p-12" data-testid={`devotion-${d.id}`}>
                <div className="flex items-center gap-4">
                  <ChaliceIcon className="w-7 h-7 text-gold" />
                  <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-crimson">
                    {new Date(d.created_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                  </span>
                </div>
                <h2 className="font-display text-2xl sm:text-3xl uppercase tracking-wide text-parchment mt-5">{d.title}</h2>
                <p className="font-serif italic text-lg text-gold/90 mt-3">{d.verse}</p>
                <p className="mt-6 text-stone-300 leading-relaxed text-sm sm:text-base whitespace-pre-line">{d.body}</p>
                <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-stone-500">— {d.author}</p>
              </article>
          </Reveal>
        ))}
      </section>
    </main>
  );
}
